import { fetchTenancyData } from "../../apis/tenancy-apis";

export const createTenancySlice = (set) => ({
    tenancyData: null,
    fetchTenancy: async (options) => {
        const data = await fetchTenancyData(options);
        set((state) => ({ ...state, tenancyData: data[0] }));
    },
});